import React, { useEffect, useState } from "react";
import { Form, ToggleButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaMapMarkedAlt } from "react-icons/fa";
import {
  MdGridView,
  MdLocationOn,
  MdOutlineCancel,
  MdOutlineFormatListBulleted,
  MdOutlineSearch,
} from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { apiGetLocalisations } from "../../../api/ApiLocalisation";
import MapGoogle from "../localisation/MapGoogle";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const BlocFiltreMobilities = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { infoViewMobility, setInfoViewMobility, setFilterMobilities, mobilities } = props;
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const [localisationFilter, setLocalisationFilter] = useState([]);
  const [localisationSelected, setLocalisationSelected] = useState("");
  const [showLocalisation, setShowLocalisation] = useState(false);
  const [filtresAllumes, setFiltresAllumes] = useState([]);

  let queryParams = useQuery();

  const cancelFiltres = () => {
    setShowSearch(false);
    setShowLocalisation(false);
    setLocalisationSelected("");
    setQuery("");
  };

  const recupLocalisations = async () => {
    const res = await apiGetLocalisations(ReduxInstance._id);
    if (res.data) {
      setLocalisationFilter(res.data);

      if (queryParams.get("localisation")) {
        setLocalisationSelected(queryParams.get("localisation"));
        setShowLocalisation(true);
      }
    }
  };

  const filterMobilitiesByQuery = (mobility, query) => {
    const searchString = query.toUpperCase();
    const regex = new RegExp(searchString);
    return mobility.filter((mobility) => {
      const mobilityNom = mobility.nom.toUpperCase();
      /* si on trouve la recherche peu importe ou dans le nom / if (mobilityNom.search(regex) === 0) pour chercher au debut du nom*/
      if (mobilityNom.search(regex) > -1) {
        return true;
      }
      return false;
    });
  };

  const filterMobilitiesByLocalisation = (mobilities, localisation) => {
    return mobilities.filter((mobility) => mobility.localisation._id === localisation);
  };

  const toggleBoutonsFiltresMobilities = () => {
    let filtresAllumesPreparation = [];

    /* localisation selectionnee */
    if (localisationSelected !== "") filtresAllumesPreparation.push("localisation");

    setFiltresAllumes(filtresAllumesPreparation);
  };

  const InfosTiersLieu = () => {
    const localisation = localisationFilter.filter((item) => item._id === localisationSelected);

    if (localisation.length === 1) {
      return (
        <div className="d-flex ms-2">
          <div
            className="mt-1 me-2"
            id="toggleGoogleMap"
            onClick={(e) => {
              document.getElementById("MapGoogle").style.display = "block";
              document.getElementById("toggleGoogleMap").style.display = "none";
            }}
          >
            <FaMapMarkedAlt size="2em" role="button" />
          </div>
          <div>
            <div>
              <h1>{localisation[0].nom}</h1>
            </div>
            <div>{localisation[0].adresse}</div>
            <div> {localisation[0].pays}</div>
          </div>
        </div>
      );
    }

    return <></>;
  };

  useEffect(() => {
    /* on recopie le tableau d'origine */
    let mobilitiesCopy = mobilities;

    /* on applique le filtre localisation si renseigné */
    if (localisationSelected && localisationFilter.length > 0) {
      mobilitiesCopy = filterMobilitiesByLocalisation(mobilitiesCopy, localisationSelected);
    }

    /* moteur de recherche */
    if (query) {
      mobilitiesCopy = filterMobilitiesByQuery(mobilitiesCopy, query);
    }
    /* permet de mettre en jaune les filtres actifs (ceux ou l'on a dcoche des cases par exemple) */
    toggleBoutonsFiltresMobilities();

    setFilterMobilities(mobilitiesCopy);
  }, [query, localisationSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    recupLocalisations();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="d-flex mb-3 justify-content-left  flex-wrap">
        <div className="blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          <ToggleButton
            size="sm"
            id="toggle-check-info-mobilites"
            type="checkbox"
            variant=""
            checked={infoViewMobility}
            value="1"
            onChange={(e) => setInfoViewMobility(e.currentTarget.checked)}
          >
            {!infoViewMobility ? (
              <MdGridView size="2em" />
            ) : (
              <MdOutlineFormatListBulleted size="2em" />
            )}
          </ToggleButton>
        </div>
        <div
          className={
            filtresAllumes.includes("localisation")
              ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
              : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
          }
        >
          <MdLocationOn
            size="1.5em"
            onClick={(e) => {
              setShowLocalisation(!showLocalisation);
              setShowSearch(true);
            }}
            role="button"
          />
        </div>
        <div className="blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          <MdOutlineSearch
            size="2em"
            onClick={(e) => {
              setShowSearch(true);
            }}
            role="button"
          />

          {showSearch && (
            <Form.Control
              type="text"
              name="nom"
              placeholder={t("commun.form.placeholder.rechercheMobilities")}
              value={query}
              className="border-0 "
              onChange={(e) => setQuery(e.target.value)}
            />
          )}
        </div>

        {(localisationSelected || query) && (
          <div className="d-flex m-2 align-items-center  ">
            <MdOutlineCancel
              size="1.5em"
              role="button"
              onClick={() => cancelFiltres("")}
              className="ms-2 text-danger"
            />
          </div>
        )}
      </div>
      {showLocalisation && (
        <div className="d-flex  flex-wrap border-bottom pb-3 mb-3">
          <MapGoogle
            coordonnees={localisationFilter}
            setCountrySelected={setLocalisationSelected}
          />
          <InfosTiersLieu />
        </div>
      )}
    </>
  );
};

export default BlocFiltreMobilities;
